import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React, {useMemo} from "react";
import {Control} from "react-hook-form";
import {getAutocompleteOutgoingNumbers} from "../../common/util/helpers";
import {useSelector} from "react-redux";
import {selectedSiteSelector} from "../../authentication/redux";

type Props = {
    index: number
    control: Control<any>
}


export const OutgoingNumberForm = ({ index, control }: Props) => {
    const { t } = useTranslation()

    const site = useSelector(selectedSiteSelector)

    const outgoingNumberOptionParams = useMemo(() => {
        return getAutocompleteOutgoingNumbers(t, site)
    }, [site, t])

    return (<FormRow>
        <FormFieldBox>
            <TextInput
                readonly={false}
                label={t('users.edit.outgoing-number')}
                name={`fieldUpdates.${index}.values.0.stringValue`}
                control={control}
                required={false}
                autoCompleteOptions={outgoingNumberOptionParams}
            />
        </FormFieldBox>
    </FormRow>)
}